@if (!isLoading() && !isCheckingAuthState()) {
    <router-outlet />
} @else {
    <div class="loading-container">
        <mat-spinner [diameter]="64" />
    </div>
}
